import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import {Link} from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import {AGENTS_LIST, AGENTS_LIST_COUNT} from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import FilterButton from '../FilterButton';
import FindDuplicateContacts from '../FindDuplicateContacts';
import fetchFilteredIds from '../FindDuplicateContacts/fetchFilteredIds';
import OpenInCrmButton from "../OpenInCrmButton/OpenInCrmButton";
import {buildServerQuery, applyClientSort} from "../../sort-utils";
import Alert from "../Alert";
import {can} from "../../access";
import {AUDIENCE_AGENTS} from "../MailMerge/merge";
import ContactSelectionBar, {CHECKBOX_COLUMN, SelectableContactList} from "../ContactSelection";

// The page size the Properties list uses, so the header box ticks the same hundred.
const limit = 100;

export default class AgentList extends SelectableContactList {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            error: null,
            isBusy: null,
            findDupsOpen: false,
        };
    }

    mailMergeList() {
        return {audience: AUDIENCE_AGENTS, noun: 'agent', plural: 'agents', queryName: AGENTS_LIST, filterKey: 'agents'};
    }

    componentDidMount() {
        this.fetch(this.props.location.query);
    }

    fetch(q) {
        this.setState({isBusy: true});
        this.beginSelectionFetch(q);

        const query = {...q};
        const options = filter(buildServerQuery(query), 'agents');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        Promise.all([
            executeBackendQuery({queryName: AGENTS_LIST, options: options}),
            executeBackendQuery({queryName: AGENTS_LIST_COUNT, options: options})
        ]).then(res => {
            this.setState({
                items: this.withSelection(applyClientSort(res[0].data, query.order)),
                totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
                error: res[0].success ? null : res[0].message,
                isBusy: null,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    render() {
        const query = this.props.location.query;

        const columns = [
            CHECKBOX_COLUMN,
            // Edit column temporarily disabled
            // {
            //     name: 'View',
            //     textAlign: 'center',
            //     columnStyle: {width: 70},
            //     render: (el) => (
            //         <Link to={{pathname: `${arc.path.base}agent/${el.ARCIMEDES_ROW_ID}`}}><Icon svg={svgEdit}/></Link>
            //     ),
            // },
            {
                code: 'NAME',
                name: 'Name',
                render: (el) => (
                    <Link to={{pathname: `${arc.path.base}agent/${el.ARCIMEDES_ROW_ID}`}}>{el.NAME}</Link>
                ),
            },
            {
                code: 'EMAIL',
                name: 'Email',
                render: (el) => el.EMAIL ? <a href={`mailto:${el.EMAIL}`}>{el.EMAIL}</a> : null,
            },
            {
                code: 'PHONE',
                name: 'Work Phone',
                render: (el) => el.PHONE ?
                    <a href={`tel:${el.PHONE.replace(' ', '-').replace('/[()]/g', '')}`}>{el.PHONE}</a> : null,
            },
            {
                code: 'CELL_PHONE',
                name: 'Cell Phone',
                render: (el) => el.CELL_PHONE ?
                    <a href={`tel:${el.CELL_PHONE.replace(' ', '-').replace('/[()]/g', '')}`}>{el.CELL_PHONE}</a> : null,
            },
            {
                code: 'LEAD_ID',
                name: 'Lead ID',
                render: (el) => (
                    <OpenInCrmButton
                        leadId={el.LEAD_ID}
                        entityType="vendor"
                        variant="link"
                        label="Open in CRM"
                    />
                ),
            },
            {
                code: 'FIRM_NAME',
                name: 'Firm',
                render: (el) => el.FIRM_NAME,
            },
            {
                code: 'FIRM_STATE',
                name: 'State',
                render: (el) => el.FIRM_STATE,
            },
            {
                // Placed by the firm's ZIP, as the Market filter matches it.
                name: 'Market',
                render: (el) => el.FIRM_MARKET,
            },
        ];

        return (
            <div className='AgentList' data-is-busy={this.state.isBusy}>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container list'>
                        <div className='page-header list' style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%'}}>
                                <div className='page-title'>Agents</div>
                                <LinkComp to={`${arc.path.base}agent`}>
                                    <div className="button-new plus positive">
                                        <Icon svg={plus}/>
                                    </div>
                                </LinkComp>
                                <button
                                    type="button"
                                    className="button-new text"
                                    onClick={() => this.setState({findDupsOpen: true})}
                                    title="Find agents recorded more than once"
                                >
                                    Find Dups
                                </button>
                                {can('mail_merge') && (
                                    <button
                                        type="button"
                                        className={`button-new text ${this.state.preparingMailMerge ? 'inactive' : ''}`}
                                        onClick={this.startMailMerge}
                                        disabled={this.state.preparingMailMerge || this.state.totalCount === 0}
                                        title={this.mailMergeTitle()}
                                    >
                                        {this.mailMergeLabel()}
                                    </button>
                                )}
                            </div>
                            <FilterButton onClick={this.props.openFilter} />
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                {this.state.mailMergeError ? <Alert type="error">{this.state.mailMergeError}</Alert> : null}
                <FindDuplicateContacts
                    open={this.state.findDupsOpen}
                    entity="agents"
                    label="Agent"
                    plural="Agents"
                    route="agent"
                    fetchFilteredSet={() => fetchFilteredIds(AGENTS_LIST, 'agents', query)}
                    filteredCount={this.state.totalCount}
                    onClose={() => this.setState({findDupsOpen: false})}
                />
                <div className='page-body-container'>
                    <ContactSelectionBar {...this.selectionBarProps()} />
                    <SortTable columns={columns}
                               items={this.state.items}
                               query={query}
                               {...this.selectionTableProps()}
                    />
                    <ListResults query={this.props.location.query}
                                 pathname={this.props.location.pathname}
                                 error={this.state.error}
                                 totalCount={this.state.totalCount}
                                 itemCount={this.state.items ? this.state.items.length : false}
                                 limit={limit}
                    />
                </div>
            </div>
        );
    }
}
